import store from "../store";
import { SEARCH_ADMIN_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";

class SearchAdminClass {
  private getState() {
    return store.getState().searchAdmin;
  }

  constructor() {}

  // this function will be called when the user clicks on the search button
  public setSearchType(
    searchType: "brand" | "product" | "all" | "venue" | "user" | "current-customer" | "add-customer",
    handler: Function,
  ): this {
    // Reset search results when changing the type
    store.dispatch(
      SEARCH_ADMIN_UPDATE({
        data: {
          search: "",
          searchType: searchType,
          searchResults: [],
        },
      }),
    );

    handler("");
    console.log("search type:", this.getState().searchType);

    return this;
  }

  // this function will be called when the user starts typing in the search bar
  public setSearchQuery(search: string): this {
    // set the search query in the store
    store.dispatch(
      SEARCH_ADMIN_UPDATE({
        data: {
          search: search,
          searchType: this.getState().searchType,
          searchResults: this.getState().searchResults,
        },
      }),
    );

    console.log("search query:", this.getState().search);

    this.performSearch();
    return this;
  }

  public async performSearch() {
    try {
      console.log("performing search with this search type:", this.getState().searchType);
      let endpoint = "";
      if (this.getState().searchType === "brand") {
        endpoint = "search/brands?name=" + this.getState().search;
      } else if (this.getState().searchType === "product") {
        endpoint = "search/products?searchTerm=" + this.getState().search;
      } else if (this.getState().searchType === "venue") {
        endpoint = "search/venues?name=" + this.getState().search;
      } else if (this.getState().searchType === "user") {
        endpoint = "admin/search-users?searchTerm=" + this.getState().search;
      } else if (this.getState().searchType === "current-customer") {
        endpoint = "admin/search-customers?current=true&searchTerm=" + this.getState().search;
      } else {
        throw new Error("Invalid search type");
      }

      const data = {
        endpoint,
      };

      console.log("getting search results with this data:", data);

      const res = await DatabaseInstance.getRecord(data);

      console.log("search results:", res);

      store.dispatch(
        SEARCH_ADMIN_UPDATE({
          data: {
            search: this.getState().search,
            searchType: this.getState().searchType,
            searchResults: res,
          },
        }),
      );
    } catch (error) {
      console.error("Search error:", error);
    }
  }

  // public filterSearchResults(searchResults: any[], filterResults: any[]): any[] {

  //     const filterNames = filterResults.map(item => item.name);

  //     const filteredResults = searchResults.filter(result => !filterNames.includes(result.name));

  //     return filteredResults;
  // }
}

const SearchAdminInstance = new SearchAdminClass();
export { SearchAdminInstance };
